module.exports = __webpack_public_path__ + "static/img/exit.308490f4.png";